import { render } from "./UserText.vue?vue&type=template&id=bd3023c4"
import script from "./UserText.vue?vue&type=script&lang=js"
export * from "./UserText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__